import React, { FC } from 'react';

interface OwnProps {
  id?: string;
  key?: string;
  onClick?: () => void | null;
}

export const RolloutIcon: FC<OwnProps> = ({ id, key, onClick }) => {
  return (
    <svg
      id={id}
      key={key}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <path
        d="M5.79302 15.3919L4.03052 16.0857C3.78052 16.1857 3.54614 16.1607 3.32739 16.0107C3.10864 15.8607 2.99927 15.6544 2.99927 15.3919L2.99927 12.0544C2.99927 11.8044 3.05864 11.5669 3.17739 11.3419C3.29614 11.1169 3.46177 10.9357 3.67427 10.7982L4.49927 10.2544C4.58677 11.2669 4.72114 12.1419 4.90239 12.8794C5.08364 13.6169 5.38052 14.4544 5.79302 15.3919ZM8.41802 2.41694C8.49302 2.34194 8.58364 2.28882 8.68989 2.25757C8.79614 2.22632 8.89927 2.21069 8.99927 2.21069C9.09927 2.21069 9.20239 2.22632 9.30864 2.25757C9.41489 2.28882 9.50552 2.34194 9.58052 2.41694C10.443 3.20444 11.1243 4.23257 11.6243 5.50132C12.1243 6.77007 12.3743 8.10444 12.3743 9.50444C12.3743 10.4669 12.293 11.3107 12.1305 12.0357C11.968 12.7607 11.718 13.5544 11.3805 14.4169C11.318 14.5794 11.2243 14.7169 11.0993 14.8294C10.9743 14.9419 10.8243 14.9982 10.6493 14.9982H7.34927C7.17427 14.9982 7.02427 14.9419 6.89927 14.8294C6.77427 14.7169 6.68052 14.5794 6.61802 14.4169C6.28052 13.5544 6.03052 12.7576 5.86802 12.0263C5.70552 11.2951 5.62427 10.4544 5.62427 9.50444C5.62427 8.10444 5.87427 6.77007 6.37427 5.50132C6.87427 4.23257 7.55552 3.20444 8.41802 2.41694ZM8.99927 9.74819C9.41177 9.74819 9.76489 9.60132 10.0586 9.30757C10.3524 9.01382 10.4993 8.66069 10.4993 8.24819C10.4993 7.83569 10.3524 7.48257 10.0586 7.18882C9.76489 6.89507 9.41177 6.74819 8.99927 6.74819C8.58677 6.74819 8.23364 6.89507 7.93989 7.18882C7.64614 7.48257 7.49927 7.83569 7.49927 8.24819C7.49927 8.66069 7.64614 9.01382 7.93989 9.30757C8.23364 9.60132 8.58677 9.74819 8.99927 9.74819ZM12.2055 15.3919C12.618 14.4544 12.9149 13.6169 13.0961 12.8794C13.2774 12.1419 13.4118 11.2669 13.4993 10.2544L14.3243 10.7982C14.5368 10.9357 14.7024 11.1169 14.8211 11.3419C14.9399 11.5669 14.9993 11.8044 14.9993 12.0544V15.3919C14.9993 15.6544 14.8899 15.8607 14.6711 16.0107C14.4524 16.1607 14.218 16.1857 13.968 16.0857L12.2055 15.3919Z"
        fill="#00B14F"
      />
    </svg>
  );
};
